export enum CryptoCurrency {
  BCH = "BCH",
  BTC = "BTC",
  ETH = "ETH",
  LTC = "LTC",
}
